export const passwordPlaceholder = { de: 'Password', en: 'Password', sv: 'Lösenord' };
export const namePlaceholder = { de: 'Alias', en: 'Alias', sv: 'Alias' };
export const repeatPasswordPlaceholder = {
  de: 'Repeat password',
  en: 'Repeat password',
  sv: 'Upprepa lösenord',
};
export const header = { de: 'Set password', en: 'Set password', sv: 'Sätt lösenord' };
export const successLabel = {
  de: 'An email has been sent with instructions on how to reset your password.',
  en: 'An email has been sent with instructions on how to reset your password.',
  sv: 'Ett email har skickats med instruktioner för att återställa ditt lösenord.',
};
export const loadingLabel = { de: 'Submitting...', en: 'Submitting...', sv: 'Skickar...' };
export const resetSuccessLabel = {
  de: 'Your password has been reset successfully!',
  en: 'Your password has been reset successfully!',
  sv: 'Ditt lösenord har återställts',
};
